<template>
    <div>
         <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
  
        
        :is-full-page="fullPage"></loading>
      <div>
  <b-card title="Sign up" >
    <div style="padding:10px;">
    <b-form-input v-model="customer.username" placeholder="Username"></b-form-input>
    
  </div>
   <div style="padding:10px;">
    <b-form-input type="password" v-model="customer.password" placeholder="Password"></b-form-input>
    
  </div>
  <div style="padding:10px;">
    <b-form-input type="password" v-model="ConfirmPassword" placeholder="Confirm Password"></b-form-input>
    
  </div>

    <b-card-text class="text-danger" v-if="alerttxt">password does not match </b-card-text>
 
 <div>
  
  <b-button variant="danger" style="margin-right:1em;">Cancel</b-button>
  <b-button style="background-color: #17a2b8;" @click="regsiter">Register</b-button>
  
</div>
<br>
    <span @click="login" style="margin-top:1em;">Do you have an account  ?<b style="color:red;"> Sign In now</b></span>
  </b-card>
</div>
    </div>
</template>
<script>
import Vue from 'vue'
 import axios from 'axios';
import Router from '../router';
 import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
     components: {
            Loading
        },
     data: () => ({
          snackbar: {
                show: false,
                message: null,
                color: null
            },
          isLoading: false,
          fullPage: true,
            customer:{
                username:'',
                password:'',
                remarks:'',
                IsActive: true,

                

            },
            ConfirmPassword:'',
            alerttxt:false,
            localAddress:[],
            updateaddress:{
              customerids:[],
              username:''
            },
            temp:[]
      }),
      mounted(){
this.localAddress = JSON.parse(localStorage.getItem("Address"));
//  this.updateusernameinaddress()
      },

      methods:{
        login(){
              Router.push('/login');
              // this.logshowModal() 
              // login
            },
          regsiter(){
                  if(this.customer.password != this.ConfirmPassword)
                  {
                    this.alerttxt = true
                  }else{

                    if(!this.customer.username)
                  {
                    this.snackbar = {
                       message: "Enter all informations...",
                        color: 'danger',
                        show: true
                    }
                  }
                  else if(!this.customer.password)
                  {
                    this.snackbar = {
                        message: "Enter all informations...",
                        color: 'danger',
                        show: true
                    }
                  }else{
                    this.alerttxt = false
                     
                 this.isLoading = true;
                 axios.post(this.$bURL+"registeredcustomer",this.customer)
                   .then((response)  =>  {
                     localStorage.setItem("logeduserId",this.customer.username)
                    console.log(response.data)
                    this.updateusernameinaddress()
                    this.accountDetails()
                    
                        this.isLoading = false;
                    this.snackbar = {
                        message: "Registered Successfully...",
                        color: 'Success',
                        show: true
                    }

                    
      
                   }, (error)  =>  {
                       console.log(error)
                       this.isLoading = false;
                       this.snackbar = {
                        message: "Username already exists",
                        color: 'danger',
                        show: true
                    }
          
                   })
                  }

                 }//here

                     


                  },
                  //=====================================
                  updateusernameinaddress(){
                     if(this.localAddress){
                    if(this.localAddress.length > 0){
                      
                         for(this.i=0;this.i<this.localAddress.length; this.i++)
                          {
                            console.log(this.localAddress[this.i].cid);
                            this.temp.push(this.localAddress[this.i].cid)
                            
                          }
                          this.updateaddress.customerids =  this.temp.toString()
                          this.updateaddress.username = this.customer.username
                          this.updateonlineaddressbyusername()
                    }
                         
                     }
                  },


                  //======================================

                  updateonlineaddressbyusername(){
                      this.isLoading = true
                     axios.patch(this.$bURL+"onlinecustomer/UpdateOnlineCustomersUsername?Customerids="+this.updateaddress.customerids+"&Username="+this.updateaddress.username)
                      .then((response)  =>  {


                         console.log(response)
                        this.isLoading = false
                        //  thisaccountDetails()

                      }, (error)  =>  {
                          console.log(error)
                          this.isLoading = false
                      })
                   
                  },
                  //+++++++++++++++++++++++++++++++++++++
         accountDetails()
          {
              axios.get(this.$bURL+"registeredcustomer/"+this.customer.username)
              .then((response)  =>  {
               console.log(JSON.stringify(response.data))
               localStorage.setItem("Logeduser",JSON.stringify(response.data))
               localStorage.setItem("islogedIn",true)
               
                Router.push('/account');
             }, (error)  =>  {
                  console.log(error)
                   this.snackbar = {
                        message: "Something went wrong..",
                        color: 'danger',
                        show: true
                    }
                  
                  
             })
                
               
           
          },





          },
          //------------------------------------------

          
     
     
     }
     

</script>
<style scoped>

</style>